import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { LessonCard } from '../../../../interfaces/lesson-card.interface';
import { ApiV2Service } from '../../../../services/api-v2.service';
import { AuthService } from '../../../../services/auth.service';
import { map } from 'rxjs/operators';
import { MessagesModalService } from '../../../../services/messages-modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lesson-card',
  templateUrl: './lesson-card.component.html',
  styleUrls: ['./lesson-card.component.css']
})
export class LessonCardComponent implements OnInit {
  scaleCard: string;
  cardSizeScaled: number;
  canEdit: boolean;
  canDelete: boolean;
  actCount: number;
  isInstalled:boolean;

  @Input() cardSize: number;
  @Input() lessonCardInfo: LessonCard;
  @Output('reload') deleteLesson: EventEmitter<any> = new EventEmitter();
  @Output('reload') unsubscribeLesson: EventEmitter<any> = new EventEmitter();

  constructor(
    private translate:TranslateService,
    private api: ApiV2Service,
    private router: Router,
    private spinner: SpinnerService,
    private auth: AuthService,
    private message: MessagesModalService
  ) { }

  ngOnInit(): void {
    //this.getActivitiesByLesson();
    if (this.auth.currentUser.isSuperuser
      || (this.auth.currentMainOrganization.organizationType === 'Familia' && this.lessonCardInfo.owner.id === this.auth.currentUser.id)
      || (this.auth.currentMainOrganization.organizationType === 'Escuela' && this.lessonCardInfo.owner.id === this.auth.currentUser.id)) {
      this.canEdit = true;
      this.canDelete = true;
    } else {
      this.canEdit = false;
      this.canDelete =false;
    }
    if(this.lessonCardInfo.isInstalled){
      this.isInstalled=true;
    }


  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.cardSize)
    if (this.cardSize<240){
      this.scaleCard=`scale(${this.cardSize / 60})`;
    }
    else{
    this.scaleCard = `scale(${this.cardSize / 240})`;}
    this.cardSizeScaled = this.cardSize / (this.cardSize / 240);
  }
          

  onCourse() {
    this.spinner.showSpinner = false;
    this.message.openGradeCourseDialog('info', this.translate.instant('DIALOGMESSAGECOURSE.ADDTOCOURSETITLE'), this.lessonCardInfo.id).afterClosed()
      .subscribe((result: any[]) => {
        console.log(result);
        if (result) {
          const courses1 = result;
          console.log(courses1);
          const body = { "grades": [this.lessonCardInfo.id] }
          console.log(body);
          let i = 0;
          const n = courses1.length;
          for (let course of courses1) {
            console.log(course)
            this.api.postAlternativeService('ADD_LESSONS_TO_COURSE', body, course).subscribe(
              (data) => {
                console.log(data);
                this.spinner.showSpinner = false;
                this.message.openDialog('success', `${this.translate.instant('LESSONS.LESSON')} ${this.lessonCardInfo.name} ${this.translate.instant('LESSONS.DIALOGMESSAGE.LESSONADD')}`).afterClosed()
                  .subscribe((result: boolean) => {
                  });
              }
              ,
              (error) => {
                console.log('Error: ', error);
                this.spinner.showSpinner = false;
              }
            );

          }
        }
      })
  }


  onEdit() {
    this.router.navigate(['lessons/lesson-creator', this.lessonCardInfo.id]);
  }

  /* onDeactivate() {
    console.log('Desactivando:' + this.lessonCardInfo.id);
  } */

  onDelete() {
    this.message.openDialog('warning', this.translate.instant('LESSONS.DIALOGMESSAGE.DELETETITLE'), this.translate.instant('LESSONS.DIALOGMESSAGE.DELETEMSG')).afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          this.spinner.showSpinner = true;
          this.api.deleteAlternativeService('DELETE_LESSON', this.lessonCardInfo.id).subscribe(
            (data) => {
              this.deleteLesson.emit();
              this.spinner.showSpinner = false;
            },
            (error) => {
              console.log(error);
              this.spinner.showSpinner = false;
            }
          );
        }
      });
      this.spinner.showSpinner = false;
  }

  onUnsubscribe() {
    this.message.openDialog('warning', this.translate.instant('LESSONS.DIALOGMESSAGE.UNSUBSCRIBE'), this.translate.instant('LESSONS.DIALOGMESSAGE.UNSUBSCRIBEMSG')).afterClosed()
      .subscribe((result: boolean) => {
        if (result) {
          this.spinner.showSpinner = true;
          this.api.deleteAlternativeService('INSTALL_LESSON', this.lessonCardInfo.id).subscribe(
            (data) => {
              this.unsubscribeLesson.emit();
              this.spinner.showSpinner = false;
            },
            (error) => {
              console.log(error);
              this.spinner.showSpinner = false;
            }
          );
        }
      });
      this.spinner.showSpinner = false;
  }

  onVisibility() {
    const body = { is_public: !this.lessonCardInfo.isPublic };
    const id = this.lessonCardInfo.id;
    this.api.patchAlternativeService('SHOW_HIDE_LESSON', body, id).subscribe(
      (lesson) => {
        this.lessonCardInfo.isPublic = lesson['is_public'];
      },
      (error) => {
        console.log('Error: ', error);
      }
    );
  }

  getActivitiesByLesson() {
    const params = { grades: this.lessonCardInfo.id }
    this.api.getService('GET_ACTIVITIES_BY_LESSON', params).pipe(map((data) => {
      delete data['results'];
      delete data['next'];
      delete data['previous']
      return data['count'];
    })).subscribe(
      (count: number) => {
        this.actCount = count;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  goToInfo() {
    if(this.lessonCardInfo.owner.id === this.auth.currentUser.id){
      console.log("es dueño")
      this.router.navigate(['/lessons/lesson-info/', this.lessonCardInfo.id]);
    }
    else{
      console.log("no es dueño")
    this.router.navigate(['/lessons/lesson-info/', this.lessonCardInfo.id,'/']);
    }
  }
}
